import { z } from "zod";

const VALIDATION_MESSAGE = {
	rejectReason: "非承認理由は必須入力です",
	insufficientAmount: "不足金額は1円以上で入力してください",
};

export const ReservationDetailLocalCancelFeeTransferRejectInputZodSchema = z.object({
	rejectReason: z
		.string()
		.min(1, { message: VALIDATION_MESSAGE.rejectReason })
		.optional() // undefined 時に、カスタムエラーとしたいので optional にしている
		.transform((value, ctx) => {
			if (value === undefined) return ctx.addIssue({ code: "custom", message: VALIDATION_MESSAGE.rejectReason });
			return value;
		}),
	insufficientAmount: z
		.number()
		.positive({ message: VALIDATION_MESSAGE.insufficientAmount })
		.optional() // undefined 時に、カスタムエラーとしたいので optional にしている
		.transform((value, ctx) => {
			if (value === undefined)
				return ctx.addIssue({ code: "custom", message: VALIDATION_MESSAGE.insufficientAmount });
			return value;
		}),
});

export type ReservationDetailLocalCancelFeeTransferRejectInputType = z.infer<
	typeof ReservationDetailLocalCancelFeeTransferRejectInputZodSchema
>;
